<template>


  <div v-if="ready">
    <notifications/>
    <router-view/>
  </div>
  <div v-else class="flex justify-center items-center min-h-screen">
    <div v-if="initTimedOut" class="text-center">
      <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-100">Aplikaci se nepodařilo načíst</h2>
      <p class="text-gray-500 mt-2">Nepodařilo se dokončit přihlášení. Zkuste obnovit stránku.</p>
      <button
          type="button"
          class="mt-4 px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          @click="reloadPage"
      >
        Obnovit stránku
      </button>
    </div>
    <div v-else class="text-center">
      <div
          class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full"
          style="border-top-color: transparent"
          aria-hidden="true"
      ></div>
      <h2 class="text-xl font-semibold mt-4">Vue Admin</h2>
      <p class="text-gray-500">Načítání...</p>
    </div>
  </div>

</template>

<script>
import Notifications from "@/components/notifications.vue";
import {watch} from 'vue';
import {
  useAppStore,
} from "@/stores/appStore"
import {useAuth0} from '@auth0/auth0-vue';
import {useRouter} from "vue-router";
import {useNotificationStore} from "@/stores/notificationStore";
import {useModuleStore} from "@/stores/moduleStore";

// Jak dlouho čekáme na inicializaci, než uživateli nabídneme obnovení stránky.
// Přesměrování na Auth0 běžně proběhne během jednotek sekund.
const INIT_TIMEOUT_MS = 10000;

export default {
  components: {Notifications},
  setup() {
  },
  data() {
    return {
      appStore: useAppStore(),
      ready: false,
      initTimedOut: false,
      initTimer: null,
      notificationStore: useNotificationStore(),
    };
  },
  methods: {
    reloadPage() {
      window.location.reload();
    }
  },
  async created() {
    this.notificationStore.notify = this.$notify;
    // Pojistka proti věčnému spinneru. Pokrývá i případ, kdy $apisReady nikdy
    // nedoresolvuje (zaseknutý Auth0) nebo kdy přesměrování na login neproběhne.
    this.initTimer = setTimeout(() => {
      if (!this.ready) this.initTimedOut = true;
    }, INIT_TIMEOUT_MS);

    let apisReady;
    try {
      apisReady = await this.$apisReady;
    } catch (e) {
      console.error("APIs failed to initialize:", e);
      this.appStore.auth0.loginWithRedirect();
      return;
    }
    // Plugin resolvuje false, když API klienti nevznikli - nepřihlášený uživatel
    // nebo chybějící refresh token. V obou případech už běží přesměrování na
    // Auth0, takže necháme viset loader. Bez téhle kontroly se vykreslí
    // router-view a views spadnou na nedefinovaných $...Api klientech.
    if (!apisReady) return;
    clearTimeout(this.initTimer);
    this.ready = true;
    console.log("APIs are ready, rendering app...");
  },
  async mounted() {
    const {isAuthenticated, getAccessTokenSilently, user, checkSession, loginWithRedirect} = useAuth0();
    const appStore = useAppStore();
    const router = useRouter();
    const moduleStore = useModuleStore();

    const loadUserData = async () => {
      try {
        const token = await getAccessTokenSilently();
        if (!token) {
          await appStore.logout();
          return;
        }

        await checkSession();

        // Stejný důvod jako v created() - bez API klientů nemá smysl pokračovat.
        if (!await this.$apisReady) return;
        console.log("managers ready");

        // stažení mongo user
        appStore.mongoUser = await this.$usersApi.getMe().then(response => response.data)

        // pokud nejsou stažený projekty tak je stáhnout
        if (!appStore.selectedProject || !appStore.projects) {
          appStore.projects = await this.$usersApi.getUsersProjects().then(response => response.data);
          console.log(appStore.projects);
        }

       if(appStore.selectedProject) {
         console.log("loading modules...");
         // Načteme moduly a rozhodneme, zda zahrnout nastavení
         await moduleStore.fetchModules(appStore.selectedProject.spaceId, appStore.selectedProject._id);


        }

      } catch (error) {
        console.error(error);
      }
    };

    if (appStore.isAuthenticated) {
      await loadUserData();
      // pokud je uživatel přihlášený a je na homepage, přesměrovat na poslední vybraný projekt
      if (appStore.selectedProject && router.currentRoute.value.path === '/') {
        router.push({ name: 'admin', params: { ucet: appStore.selectedProject.spaceSlug, project: appStore.selectedProject.slug } });
      }
    } else {
      console.log("is not authenticated");
      await loginWithRedirect();
      appStore.resetStore();
    }

    watch(() => appStore.isAuthenticated, async (newValue) => {
      if (newValue) {
        await loadUserData();
      } else {
        console.log("is not authenticated");
        await loginWithRedirect();
        appStore.resetStore();
      }
    })
  }


};
</script>

